import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const MemoryStepOneExtraCollections = ({
  getCollectionsByGroupId,
  hasLoaded,
  memoryStepOneExtraCollections,
  memoryStepOneExtraCurrency,
  pageCount,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="memory-collections-container--step-one-extra"
      collectionsPath={paths.MEMORY_STEP_ONE_EXTRA_COLLECTIONS}
      currency={memoryStepOneExtraCurrency}
      getCollectionsByGroupId={getCollectionsByGroupId}
      hasLoaded={hasLoaded}
      items={memoryStepOneExtraCollections}
      levelsPath={paths.MEMORY_STEP_ONE_EXTRA_LEVELS}
      pageCount={pageCount}
      title={messages.game.memory}
    />
  );
};

MemoryStepOneExtraCollections.propTypes = {
  getCollectionsByGroupId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  memoryStepOneExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  memoryStepOneExtraCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepOneExtraCollections.getHasLoaded(state),
  memoryStepOneExtraCurrency: selectors.memoryStepOneExtraCollections.getCurrencyData(
    state
  ),
  memoryStepOneExtraCollections: selectors.memoryStepOneExtraCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.memoryStepOneExtraCollections.getPageCount(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepOneExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepOneExtraCollections);
